var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alm",style:(_vm.left)},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"alm-mask",on:{"click":_vm.clickMask}})])
}
var staticRenderFns = []

export { render, staticRenderFns }